export const FETCH_SALE = 'salesTurnoverDetailsPage/FETCH_SALE';

export const RETRY_FETCH = 'salesTurnoverDetailsPage/RETRY_FETCH';
